import type { Card } from '../../types'
import ProfileCard from './ProfileCard'
import LinkCard from './LinkCard'
import TextCard from './TextCard'
import PhotoCard from './PhotoCard'
import AudioCard from './AudioCard'
import SpotifyTopCard from './SpotifyTopCard'
import SpotifyCurrentCard from './SpotifyCurrentCard'
import VideoCard from './VideoCard'
import SocialIconCard from './SocialIconCard'
import ErrorBoundary from '../ErrorBoundary'

interface CardRendererProps {
  card: Card
  editMode: boolean
  cellSize: number
  themeOverride?: 'mono' | 'glass' | 'neo' | 'wood'
}

export default function CardRenderer({ card, editMode, cellSize, themeOverride }: CardRendererProps) {
  const fallback = (
    <div className="w-full h-full theme-card theme-card-hover flex items-center justify-center">
      <span className="opacity-50 font-serif text-xs">Error</span>
    </div>
  )

  let content: React.ReactNode
  switch (card.card_type) {
    case 'profile':
      content = <ProfileCard card={card} editMode={editMode} cellSize={cellSize} />
      break
    case 'link':
      content = <LinkCard card={card} editMode={editMode} cellSize={cellSize} />
      break
    case 'text':
      content = <TextCard card={card} editMode={editMode} cellSize={cellSize} />
      break
    case 'photo':
      content = <PhotoCard card={card} editMode={editMode} cellSize={cellSize} themeOverride={themeOverride} />
      break
    case 'audio':
      content = <AudioCard card={card} editMode={editMode} cellSize={cellSize} />
      break
    case 'spotify_top':
      content = <SpotifyTopCard card={card} editMode={editMode} cellSize={cellSize} />
      break
    case 'spotify_current':
      content = <SpotifyCurrentCard card={card} editMode={editMode} cellSize={cellSize} />
      break
    case 'video':
      content = <VideoCard card={card} editMode={editMode} cellSize={cellSize} />
      break
    case 'social_icon':
      content = <SocialIconCard card={card} editMode={editMode} cellSize={cellSize} />
      break
    default:
      return fallback
  }

  return <ErrorBoundary fallback={fallback}>{content}</ErrorBoundary>
}
